/*
 *
 * DS => Design Serive
 *
 *
 * */
import { createContext } from 'react'
import { useValues } from './ELoaderProvider'

export const ELoaderContext = createContext({} as ReturnType<typeof useValues>)
